import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import type { PaginatedResponse } from "@/api/types";
import { api } from "@/lib/api";
import type { Apartment, ApartmentParams } from "./types";

export function useApartments(
	params: ApartmentParams,
): UseQueryResult<PaginatedResponse<Apartment>, Error> {
	return useQuery({
		queryKey: queryKeys.districts.apartments(params),
		queryFn: async (): Promise<PaginatedResponse<Apartment>> => {
			const res = await api.get<PaginatedResponse<Apartment>>(
				"/api/districts/apartments/",
				{ params },
			);
			return res.data;
		},
	});
}

export function useApartment(pk: number): UseQueryResult<Apartment, Error> {
	return useQuery({
		queryKey: queryKeys.districts.apartment(pk),
		queryFn: async (): Promise<Apartment> => {
			const res = await api.get<Apartment>(`/api/districts/apartments/${pk}/`);
			return res.data;
		},
		enabled: !!pk,
	});
}
